import *as _ from 'lodash'
import {TransactionTypeBO} from "./TransactionTypeBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";

export class TransactionTypeBOValidations{

    static ValidateEmptyFields(aBO: TransactionTypeBO): Promise<void>{

        return new Promise<void>((resolve, error ) =>{
            //Validate Transaction Type
            if (_.isEmpty(aBO.WB_TransactionType.cif.TXNTYPE_ID) || _.isNull(aBO.WB_TransactionType.cif.TXNTYPE_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'transactionid',
                        title: "Transaction Type ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('transactionid')
            }

            if (_.isEmpty(aBO.WB_TransactionType.cif.TXNTYPE_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'transactionname',
                        title: "Transaction Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('transactionname')
            }

            if (_.isEmpty(aBO.WB_TransactionType.cif.SOURCE_ID) || _.isNull(aBO.WB_TransactionType.cif.SOURCE_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'sourceid',
                        title: "Source ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('sourceid')
            }

            if (_.isEmpty(aBO.WB_TransactionType.cif.CREDITDEBITPOLICY)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'creditdebitpolicy',
                        title: "Credit Debit Policy cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('creditdebitpolicy')
            }

            if (_.isEmpty(aBO.WB_TransactionType.cif.BALANCEPOLICY)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'balancepolicy',
                        title: "Balance Policy cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('balancepolicy')
            }

            if (_.isEmpty(aBO.WB_TransactionType.cif.FUNDTYPEPOLICY)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'fundtypepolicy',
                        title: "Fund Type Policy cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('fundtypepolicy')
            }

            if (_.isEmpty(aBO.WB_TransactionType.cif.CUSTOMERPOLICY)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'customerpolicy',
                        title: "Customer Policy cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('customerpolicy')
            }

            if (_.isEmpty(aBO.WB_TransactionType.cif.CUSTOMERLEVEL)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'customerlevel',
                        title: "Customer Level cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('customerlevel')
            }

            if (_.isEmpty(aBO.WB_TransactionType.cif.PRDGRPPOLICY)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'productgrouppolicy',
                        title: "Product Group Policy cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('productgrouppolicy')
            }

            if (_.isEmpty(aBO.WB_TransactionType.cif.PRDGRPLEVEL)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'productgrouplevel',
                        title: "Product Group Level cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('productgrouplevel')
            }

            resolve()

        })

    }
}